import { Avatar } from "@/components";

interface IProps {
  userId: string;
  size?: number;
}

export const ProfilePhoto = ({ userId, size }: IProps) => (
  <>
    <Avatar userId={userId} size={size || 175} />
  </>
);
